<template>
  <div class="container-fluid bg-light">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>
@import "~bootstrap/dist/css/bootstrap.min.css";
</style>